import List from './List';
import Show from './Show';

export default {
  name: 'onboardingCases',
  list: List,
  show: Show,
  options: {
    group: 'Integrations',
    label: 'Onboarding Cases',
  },
};
